import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { UserRoleDto } from '@unity/clients';
import { OutsideContainerComponent } from '@unity/layouts/outside-container/outside-container.component';
import { SortPipe } from '@unity/pipes/sort.pipe';
import { LayoutService } from '@unity/services/layout.service';
import { SessionService } from '@unity/services/session.service';

@Component({
  selector: 'unity-login-select-agency-page',
  standalone: true,
  imports: [KENDO_LAYOUT, KENDO_DROPDOWNLIST, KENDO_LABEL, KENDO_BUTTON, KENDO_INDICATORS, RouterLink, SortPipe, OutsideContainerComponent],
  templateUrl: './login-select-agency-page.component.html',
  styleUrl: './login-select-agency-page.component.scss',
})
export class LoginSelectAgencyPageComponent implements OnInit {
  private readonly sessionService = inject(SessionService);
  private readonly layoutService = inject(LayoutService);

  protected $hasNoValidAgencies = this.sessionService.$hasNoValidAgencies;
  protected $currentAgencyRole = this.sessionService.$currentAgencyRole;
  protected $validAgencyRoles = this.sessionService.$sessionRoles;
  protected layoutGap = this.layoutService.newRecordFormGridLayoutGap;

  protected async selectionChange(event: UserRoleDto) {
    await this.sessionService.loginToAgencyAndRedirect(event.agency_id);
  }

  protected onBack() {
    this.sessionService.logout();
  }

  protected bypassed = false;
  protected loading = true;

  public async ngOnInit() {
    // Attempt to bypass on landing if only one available agency in session
    this.bypassed = await this.sessionService.maybeRedirectToSingleAgency();
    this.loading = false;
  }
}
